<script>
export default {
  props: {
    fontCss: {
      type: String,
      default: ''
    },
    fontText: {
      type: String,
      default: ''
    },
    forId: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <!-- 判斷是否有 forId，決定渲染label或span -->
  <component
    :is="forId ? 'label' : 'span'"
    :class="fontCss"
    v-bind="forId ? { for: forId } : {}"
  >
    {{ fontText }}
    <slot name="text" />
  </component>
</template>
